import { render, staticRenderFns } from "./DoKoCard.vue?vue&type=template&id=aa832892&"
import script from "./DoKoCard.vue?vue&type=script&lang=ts&"
export * from "./DoKoCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports